SP.MobileFilterSort = Garnish.Base.extend({
    $triggerBtn: null,
    $collectionSidebar: null,
    $filterMenu: null,
    $filterCloseBtn: null,

    init() {
        this.$triggerBtn = $('.mobile-sort-trigger')
        this.$collectionSidebar = $('.collection-sidebar')
        this.$filterMenu = $('.filter-menu')
        this.$filterCloseBtn = $('.filter-close-mobile')

        this.addListener(this.$triggerBtn, 'click', this.showSidebar)
        // this.addListener($('.filter-close-mobile'), 'click', this.hideSidebar)

        $('body').on('click', '.filter-close-mobile', function (e) {
            e.preventDefault()
            $('.collection-sidebar').removeClass('show')
            $('.filter-menu').removeClass('pt-expand')
            $('body').removeClass('remove-scrolling')
        })
    },

    showSidebar() {
        if ($('.collection-sidebar').hasClass('show')) {
            $('.collection-sidebar').removeClass('show')
            this.$filterMenu.removeClass('pt-expand')
            $('body').removeClass('remove-scrolling')
        } else {
            $('.collection-sidebar').addClass('show')
            this.$filterMenu.addClass('pt-expand')
            $('body').addClass('remove-scrolling')
        }
    },

    hideSidebar(e) {
        e.preventDefault()

        $('.collection-sidebar').removeClass('show')
        this.$filterMenu.removeClass('pt-expand')
        $('body').removeClass('remove-scrolling')
    }
})